import { AlertTexts } from '../language/Texts';
import translation from '../language/translation.json';
import { ErrorTexts } from '../models/ErrorTexts';
import { IKeyValue } from '../models/IComponent';
import { ComponentType } from '../models/componentType.enum';

export class Utils {

    private static t(path: string, lang?: string): string {
        const parts = path.split('.');
        let cur: any = translation;
        for (const p of parts) {
            if (!cur) break;
            cur = cur[p];
        }
        if (!cur) return '';

        const chosenLang = lang && this.isLanguageSupported(lang) ? lang : this.getBrowserLanguage();
        return cur[chosenLang] || cur.en || cur.de || '';
    }

    static arrangeUrl(url: string): string {
        if (!(url.startsWith('http://') || url.startsWith('https://'))) {
            url = 'https://' + url
        }
        return url;
    }

    static getBrowserLanguage(): string {
        return navigator.language.substring(0, 2)
    }


    static isLanguageSupported(lang: string): boolean {
        return translation.language[lang]
    }

    static getInfoPartTitleClassName = (isEditorView: boolean) => {
        if (!isEditorView) return 'info_part_title'
        return 'info_part_title editor_info_part_title'
    }

    static errorConvertor = (error: string) => {
        switch (error) {
            case ErrorTexts.COMPONENT_EXISTS:
                return AlertTexts.componentExists
            case ErrorTexts.OUT_OF_EMAIL_LIMIT:
                return AlertTexts.outOfEmailLimit
            default:
                return error
        }
    }

    static getSnowVariables() {
        let speed: [number, number] = [0.5, 1]
        let size: [number, number] = [10, 12]
        let quantity = 50
        if (window.screen.width > 768) {
            speed = [0.5, 1]
            size = [12, 15]
            quantity = 100
        }
        if (window.screen.width > 1200) {
            speed = [0.5, 1]
            size = [7, 12]
            quantity = 130
        }
        if (window.screen.width > 2000) {
            speed = [1, 1]
            size = [10, 15]
            quantity = 180
        }
        return { speed, quantity, size }
    }

    static isTypeBatteryPass(type: ComponentType): boolean {
        return type === ComponentType.BATTERY_PASS
    }

    static getBackgroundColor(type: ComponentType): string {
        if (type === ComponentType.GEMUE_INTERNAL) {
            return 'rgba(133, 133, 233, 0.7)'
        }
        if (type === ComponentType.GEMUE_EXTERNAL) {
            return 'rgba(216, 0, 0, 0.30)'; // Example color, adjust as needed
        }
        return this.isTypeBatteryPass(type) ? 'rgba(90, 182, 243, 0.7)' : 'rgba(210, 224, 146, 0.7)'
    }

    static getDefaultParameters() {
        let type: ComponentType = ComponentType.DIGITAL_NAMEPLATE;
        let backgroundColor: string = "#D2E092";
        let defaultProductName: string = translation.exampleProduct.de;

        const params = new URLSearchParams(window.location.search);

        const typeParam = params.get('type');
        const lang = params.get('lang')?.substring(0, 2).toLowerCase();

        // determine language to use for translations
        const chosenLang = (lang && this.isLanguageSupported(lang)) ? lang : this.getBrowserLanguage();

        // set default product name according to chosen language with sensible fallbacks
        defaultProductName = this.t('exampleProduct', chosenLang) || translation.exampleProduct.de;

        if (
            typeParam === ComponentType.DIGITAL_NAMEPLATE ||
            typeParam === ComponentType.BATTERY_PASS ||
            typeParam === ComponentType.GEMUE_INTERNAL ||
            typeParam === ComponentType.GEMUE_EXTERNAL
        ) {
            type = typeParam as ComponentType;

            switch (type) {
                case ComponentType.BATTERY_PASS:
                    backgroundColor = "rgba(90, 182, 243, 1)";
                    defaultProductName = this.t('productNameBatteryPass', chosenLang) || translation.productNameBatteryPass.de;
                    break;
                case ComponentType.GEMUE_INTERNAL:
                    backgroundColor = "rgba(133, 133, 133, 1)";
                    break;
                case ComponentType.GEMUE_EXTERNAL:
                    backgroundColor = "rgba(223, 226, 235, 1)";
                    break;
            }
        }

        return { type, backgroundColor, defaultProductName, lang };
    }

    static getRedirectInfos() {
        const host = window.location.host;
        const isEditorView = (host === "d.asset-pass.com" || host === "e.asset-pass.com");
        const isStagingMode = host.includes("e.asset-pass.com");
        let redirectUrl = isStagingMode ? 'https://e.asset-pass.com' : 'https://d.asset-pass.com';
        if (this.isBatteryPass()) {
            redirectUrl += "?type=battery-pass";
        }
        if (this.isGemueInternal()) {
            redirectUrl += "?type=gemue-internal";
        }
        if (this.isGemueExternal()) {
            redirectUrl += "?type=gemue-external";
        }
        return { isEditorView, redirectUrl };
    }
    static isGemueExternal() {
        return window.location.search.includes("type=gemue-external");
    }

    static isBatteryPass() {
        return window.location.search.includes("type=battery-pass")
    }

    static isGemueInternal() {
        return window.location.search.includes("type=gemue-internal")
    }

    static getKeyValue(): IKeyValue[] {
        const params = new URLSearchParams(window.location.search);
        const lang = params.get('lang')?.substring(0, 2).toLowerCase();
        const chosenLang = (lang && this.isLanguageSupported(lang)) ? lang : this.getBrowserLanguage();

        if (this.isBatteryPass()) {
            const capKey = this.t('capacity', chosenLang);
            const capVal = "74,24 kWh";
            const weightKey = this.t('weight', chosenLang);
            const weightVal = "438kg";
            return [{ key: capKey, value: capVal }, { key: weightKey, value: weightVal }]
        }

        const matKey = this.t('material', chosenLang);
        const matVal = this.t('metal', chosenLang);
        const sizeKey = this.t('size', chosenLang);
        const sizeVal = "10mm";
        return [{ key: matKey, value: matVal }, { key: sizeKey, value: sizeVal }]
    }
}